// Constants TypeScript files should be AUTO-GENERATED by the Typewriter Visual Studio plugin. Do not modify this file.
enum MachineType {
    CenterVertical = 1,
    DriFlo = 2,
}
export default MachineType;
